import { Component, OnInit, ViewChild } from "@angular/core";
import { SelectComponent } from "@components/select/select.component";
import { TranslateService } from "@ngx-translate/core";
import { SelectValue } from "app/interfaces/select-value.interface";
import { ApiService, UserInfo } from "app/services/api.service";
import { take } from "rxjs";

@Component({
  selector: 'app-sales-support',
  templateUrl: './sales-support.component.html',
  styleUrl: './sales-support.component.scss'
})
export class SalesSupportComponent implements OnInit {
    userInfo: UserInfo;
    name: string = '';
    phone: string = '';
    email: string = '';
    reasons: SelectValue[] = [
        { id: "1", value: 'marketing_tools', label: 'sales-support.reasons.marketing_tools' },
        { id: "2", value: 'material_to_display', label: 'sales-support.reasons.material_to_display' },
        { id: "3", value: 'trainig_on_cosentino_brands', label: 'sales-support.reasons.trainig_on_cosentino_brands' },
        { id: "4", value: 'cosentino_rep_to_visit_me', label: 'sales-support.reasons.cosentino_rep_to_visit_me' },
        { id: "5", value: 'reservation_for_cosentino_events', label: 'sales-support.reasons.reservation_for_cosentino_events' },
        { id: "6", value: 'incidence', label: 'sales-support.reasons.incidence' },
        { id: "7", value: 'other', label: 'sales-support.reasons.other' }
    ];
    reason: string = '';
    selectedReason: SelectValue | null = null;
    subject: string = '';

    isConfirmModalVisible: boolean = false;
    isLoading: boolean = false;
    submitError: string | null = null;

    @ViewChild(SelectComponent) selectComponent!: SelectComponent;

    constructor(private api: ApiService, private translate: TranslateService) {}

    private translations(){
        this.translate.get([
            'sales-support.reasons.marketing_tools',
            'sales-support.reasons.material_to_display',
            'sales-support.reasons.trainig_on_cosentino_brands',
            'sales-support.reasons.cosentino_rep_to_visit_me',
            'sales-support.reasons.reservation_for_cosentino_events',
            'sales-support.reasons.incidence',
            'sales-support.reasons.other'
        ])
    }

    ngOnInit(): void {
        this.api.userInfo.pipe(take(1)).subscribe((userInfo) => {
            this.userInfo = userInfo;
            if (this.userInfo) {
                this.name = this.userInfo.accountOwnerFullName || '';
                this.email = this.userInfo.accountOwnerEmail || '';
                this.phone = this.userInfo.accountOwnerPhone || '';
            }
        });
    }

    onSubmit() {
        if (!this.selectedReason) {
            this.submitError = 'Reason is required';
            return;
        }
        this.reason = this.selectedReason.value;
        this.submitError = null;
        this.isConfirmModalVisible = true;
    }

    onReasonChange(value: SelectValue | null) {
        this.selectedReason = value;
    }

    onConfirm() {
        if (this.isLoading) {
            return;
        }

        if (!this.userInfo) {
            this.submitError = 'Can´t obtain user info';
            this.isConfirmModalVisible = false;
            return;
        }

        const payload = {
            name: this.name,
            phone: this.phone,
            email: this.email,
            reason: this.reason,
            subject: this.subject,
            userInfo: this.userInfo
        };

        this.isConfirmModalVisible = false;
        this.isLoading = true;
        this.submitError = null;

        this.api.createSalesSupport(payload).pipe(take(1)).subscribe({
            next: () => {
                this.isLoading = false;
                this.resetFormAfterSuccess();
            },
            error: (err) => {
                this.isLoading = false;
                this.submitError = 'sent_error_msg_text';
                console.error('Error creating sales support', err);
            }
        });
    }

    private resetFormAfterSuccess() {
        this.reason = '';
        this.subject = '';
        this.selectedReason = null;
        this.selectComponent.reset();
    }
}